import styled from 'styled-components';

export type ErrorStyle = 'default' | 'filled';

export const ErrorContainer = styled.div<{ errorStyle: ErrorStyle }>`
  position: absolute;
  bottom: -20px;
  left: 0;
  padding-left: 13px;
  width: 100%;
  color: rgba(175, 41, 48, 1);

  font-size: 14px;
  line-height: 16.41px;

  ${props =>
    props.errorStyle === 'filled' &&
    `
    font-size: 10px;
    line-height: 100%;
    font-weight: 500;
    padding-bottom: 2px;
    bottom: -14.5px;
    border-bottom: 1px solid #e93323;
    color: #e93323;
    background: #e933231a;
    `};
`;
